import React, { useReducer } from 'react'
import {
  GridColumnSortActionControls,
  GridColumnSortControls,
  GridColumnSortPolicies,
  GridColumnSortType,
  GRID_COL_SORT_CONFIGS_CONTROLS,
} from '../../../../components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'
import { gridColSortReducerControls } from '../../../../components/Reusable/Grid/GridColumnSort/GridColumnSort.utils'
import {
  filterBarHeight,
  headerHeight,
} from '../../../../components/PageLayout/dimensionUtils'
import { GridRow } from '../../../../components/Reusable/Grid'
import { useUrlSearchParams } from '../../../../Utils/helpers/navigation'
import { ControlsGridColumnSort } from '../../../../components/Reusable/Grid/GridColumnSort'
import {
  ControlsGridHeader,
  EvidenceHeader,
  EvidenceSubHeaders,
  EvidenceTitle,
  FrameworksHeader,
  StatusHeader,
} from './ControlsIndexGrid.styles'
import { CONTROL_GRID_LOCATIONS } from './ControlsIndexPage.constants'

export const ControlsIndexGridHeader = ({
  location,
}: {
  location?: CONTROL_GRID_LOCATIONS
}): JSX.Element => {
  const { searchParams, updateUrlParams } = useUrlSearchParams()
  const sortBy =
    (searchParams.sort_by && (searchParams.sort_by[0] as GridColumnSortType)) ||
    GridColumnSortType.ASCENDING
  const sortCol: GridColumnSortControls | GridColumnSortPolicies =
    (searchParams.sort_col &&
      (searchParams.sort_col[0] as GridColumnSortControls)) ||
    GridColumnSortControls.ID
  const [columnMapState, dispatch] = useReducer(
    gridColSortReducerControls,
    GRID_COL_SORT_CONFIGS_CONTROLS(sortBy, sortCol),
  )

  // Account for Header + Filter height when used in Controls Page
  const isControlsPage = location === CONTROL_GRID_LOCATIONS.CONTROLS_INDEX
  const top = isControlsPage ? headerHeight + filterBarHeight : 0

  const fetchSortedControls = (action: GridColumnSortActionControls) => {
    dispatch(action)
    updateUrlParams({ sort_by: [action.type], sort_col: [action.colName] })
  }

  return (
    <GridRow>
      <ControlsGridHeader top={top}>
        Dept
        {isControlsPage && (
          <ControlsGridColumnSort
            type={columnMapState[GridColumnSortControls.DEPARTMENT].type}
            isActive={
              columnMapState[GridColumnSortControls.DEPARTMENT].isActive
            }
            colName={GridColumnSortControls.DEPARTMENT}
            onSort={fetchSortedControls}
          />
        )}
      </ControlsGridHeader>
      <ControlsGridHeader top={top}>
        ID
        {isControlsPage && (
          <ControlsGridColumnSort
            type={columnMapState[GridColumnSortControls.ID].type}
            isActive={columnMapState[GridColumnSortControls.ID].isActive}
            colName={GridColumnSortControls.ID}
            onSort={fetchSortedControls}
          />
        )}
      </ControlsGridHeader>
      <ControlsGridHeader top={top}>
        Name
        {isControlsPage && (
          <ControlsGridColumnSort
            type={columnMapState[GridColumnSortControls.NAME].type}
            isActive={columnMapState[GridColumnSortControls.NAME].isActive}
            colName={GridColumnSortControls.NAME}
            onSort={fetchSortedControls}
          />
        )}
      </ControlsGridHeader>
      <FrameworksHeader top={top}>Frameworks Using This</FrameworksHeader>
      <EvidenceHeader top={top}>
        <EvidenceSubHeaders>
          <div>
            <EvidenceTitle>Automated Evidence</EvidenceTitle>
            {isControlsPage && (
              <ControlsGridColumnSort
                type={
                  columnMapState[GridColumnSortControls.AUTOMATED_EVIDENCE].type
                }
                isActive={
                  columnMapState[GridColumnSortControls.AUTOMATED_EVIDENCE]
                    .isActive
                }
                colName={GridColumnSortControls.AUTOMATED_EVIDENCE}
                onSort={fetchSortedControls}
              />
            )}
          </div>
          <div>
            <EvidenceTitle>Manual Evidence</EvidenceTitle>
            {isControlsPage && (
              <ControlsGridColumnSort
                type={
                  columnMapState[GridColumnSortControls.MANUAL_EVIDENCE].type
                }
                isActive={
                  columnMapState[GridColumnSortControls.MANUAL_EVIDENCE]
                    .isActive
                }
                colName={GridColumnSortControls.MANUAL_EVIDENCE}
                onSort={fetchSortedControls}
              />
            )}
          </div>
        </EvidenceSubHeaders>
      </EvidenceHeader>
      <StatusHeader top={top}>Status</StatusHeader>
      <ControlsGridHeader top={top} justifyContent="center">
        Assignee
      </ControlsGridHeader>
      <ControlsGridHeader top={top} />
    </GridRow>
  )
}
